export const getStorefront = async () => {
  try {
    let response = await fetch(
      `${getCurrentWebsite()}/api/locales/hmc?lang=${getLang()}`
    );
    let settings = await response.json();
    let json = JSON.parse(settings);
    return json;
  } catch (error) {
    return {};
  }
};

const getCurrentWebsite = () => {
  return "/" + window.location.pathname.split("/")[1];
};

const getDocumentLang = () => {
  return document.getElementsByTagName("html")[0].getAttribute("lang");
};

const getLang = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  if (params.lang) return params.lang;
  return getDocumentLang();
};
